import Current from '../../components/Cards/Current';
import Daily from '../../components/Cards/Daily'
import SearchBar from '../../components/SearchBar/SearchBar';
import { useState } from 'react';
import { useSelector } from "react-redux";
import LoadingComponent from '../../components/LoadingComponent/LoadingComponent';
import Navbar from '../../components/Navbar/Navbar';


const Home = () => {

  const data = useSelector(state => state.weatherData.data)
  const isLoading = useSelector(state => state.variables.isLoading)

  const [extendedForecast, setExtendedForecast] = useState(false)


  const turnForecast = () => {
    if (extendedForecast === false) {
        setExtendedForecast(true)
    }
    if (extendedForecast ===true) {
        setExtendedForecast(false)
        
    }
}


  
  return (
  
        <div className='container'>
            <Navbar/>
            <SearchBar/>
            {isLoading ? <LoadingComponent/> :<>
            {data && <Current/>}
            {data && <div className="row dflex buttonForecast">
                            <button className="extendedForecast" onClick={turnForecast} value={extendedForecast}>Show Extended Forecast</button>
                        </div>}
            {extendedForecast && <Daily/>}
            </>}
        </div>)
};

export default Home;
